export default __webpack_public_path__ + "static/media/print-carroussel-5.0c68a77a.png";